import type { Environment } from '@openeducation/oe-it-services';
import type {
  PersonProfile,
} from '@openeducation/oe-it-shared-types';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';

export interface TeacherProps<T> {
  personId: number | undefined;
  extraQueryKey?: string;
  getProfileById: (env: Environment, personId?: number) => Promise<T | null>;
}

export const usePersonProfileNoService = <
  T = PersonProfile
>({
  personId,
  extraQueryKey,
  getProfileById,
}: TeacherProps<T>) => {
  const { environment } = useEnvironmentContext();

  const {
    data,
    isLoading: isLoadingPersonProfile,
    isError: isErrorPersonProfile,
    error,
  } = useQuery<T | null>(
    ['person-profile', extraQueryKey, personId],
    () => getProfileById(environment, personId),
    {
      enabled: !!personId,
    }
  );

  return {
    personProfile: data as T | null,
    isLoadingPersonProfile,
    isErrorPersonProfile,
    errorPersonProfile: error as string,
  };
};
